import { Flex, Button, Link, Text, useToast } from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import LoginInput from '@/components/LoginInput';
import { useState } from 'react';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { NavLink } from 'react-router-dom';
import { LoginSchema } from '@/utils/loginFormValidation';
import ensureAuthenticated from '@/contexts/ensureAuthenticated';
import { axiosInstance } from '@/services/axiosInstance';
import Cookies from 'js-cookie';
import { usernameFormatter } from '@/utils/usernameFormatter';
import Logo from '../Logo';

export type ILoginInfo = {
  cellphoneOrDocument: string;
  password: string;
};

export default function LoginForm() {
  const [visiblePassword, setVisiblePassword] = useState(false);

  const { setAuthenticated } = ensureAuthenticated();

  const toast = useToast()

  return (
    <Flex
      maxW={{ base: '100%', md: '41%' }} 
      minW={{ base: '100%', md: '41%' }}
      bgColor='white'
      minH='100%'
      flexDir='column'
      align='center'
      justify='center'
    >
      <Logo variant="primary" objectFit='scale-down' mb={{ base: '0.25rem', md: '0.5rem' }} width="18.75rem"/>

      <Flex
        flexDir='column'
        w={{ base: '96%', md: '60%' }}
        align='center'
        border="1px solid #09121c1a"
        borderRadius="9px"
        padding="2rem"
        shadow="lg"
        p={{ base: '1rem', md: '2rem' }}
      >
        <Text
          mb={{ base: '1rem', md: '2rem' }}
          color="#09121c80"
          fontWeight="medium"
          fontSize={{ base: 'sm', md: 'md' }}
        >
          Seja bem-vindo(a)!
          Insira seu usuário e senha para entrar em sua conta
        </Text>
        <Formik
          initialValues={{
            username: '',
            password: '',
          }}
          validationSchema={LoginSchema}
          onSubmit={async (values, { setSubmitting }) => {

            const { data, status } = await axiosInstance
              .post('api/auth/signin', {
                id: values.username,
                password: values.password,
              })

            switch (status) {
              case 200:
                setAuthenticated({ isAuthenticated: true, user: data.user });
                Cookies.set('session', data.session, { 
                  secure: true, 
                  sameSite: 'None', 
                  path: '/'
                });
                
                Cookies.set('refreshToken', data.refreshToken, { 
                  secure: true, 
                  sameSite: 'None', 
                  path: '/'
                });
                setSubmitting(false);
                break;
              default:
                toast({
                  title: 'Erro ao Efetuar Login',
                  description: "Credenciais incorretas",
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
                });
                setSubmitting(false);
                break;
            }

          }}
        >
          {({ errors, touched, setFieldValue, values, isSubmitting }) => (
            <Form
              style={{
                width: '100%',
                rowGap: '24px',
                flexDirection: 'column',
                display: 'flex',
              }}
            >
              <LoginInput
                name='username'
                touched={touched}
                id='username'
                title='username'
                placeholder='Insira seu nome de usuário'
                setFieldValue={setFieldValue}
                value={values.username}
                formatFn={usernameFormatter}
              />
              {errors.username &&
                touched.username ? (
                <Text
                  color="red"
                >
                  {errors.username}
                </Text>
              ) : null}
              <LoginInput
                name='password'
                touched={touched}
                id='password'
                type={visiblePassword ? 'text' : 'password'}
                title='password'
                placeholder='Senha'
                isPassword={true}
                rightIcon={
                  visiblePassword ? (
                    <EyeInvisibleOutlined
                      style={{ color: '#CACDD1' }}
                    />
                  ) : (
                    <EyeOutlined
                      style={{ color: '#CACDD1' }}
                    />
                  )
                }
                onIconClick={() =>
                  setVisiblePassword(!visiblePassword)
                }
                setFieldValue={setFieldValue}
              />
              {errors.password && touched.password ? (
                <Text
                  color="red"
                >
                  {errors.password}
                </Text>
              ) : null}

              <Flex justify='flex-end' w='100%'>
                <Link
                  as={NavLink}
                  to='/auth/forgot'
                  fontFamily='Lexend Deca'
                  fontSize={{ base: '12px', sm: '14px' }}
                  fontWeight='400'
                  lineHeight='22px'
                  color="#09121c80"
                  textDecoration="underline"
                >
                  Esqueci minha senha
                </Link>
              </Flex>

              <Button
                bgColor='secondary'
                w='100%'
                color='white'
                borderRadius='0px'
                type='submit'
                isLoading={isSubmitting}
              >
                Entrar
              </Button>
            </Form>
          )}
        </Formik>
      </Flex>
    </Flex>
  );
}
